import type { ActionItemData, LaunchMetric } from "../types";

/** Set to false once end_customer_launches is wired to /dashboard/stats/. */
export const STATIC_END_CUSTOMER_LAUNCHES_DISABLED = true;

export const STATIC_ACTION_ITEMS: ActionItemData[] = [
  {
    id: "create-partner",
    title: "Create New Partner",
    subtitle: "Add a new partner",
    icon: "userPlus",
    iconVariant: "dark",
  },
  {
    id: "create-engagement",
    title: "Create Engagement Form",
    subtitle: "Start a new project workflow",
    customIcon: "engagement-document",
    iconVariant: "light",
  },
  {
    id: "create-assessment",
    title: "Create Assessment Form",
    subtitle: "Start a new assessment",
    customIcon: "assessment-clipboard",
    iconVariant: "dark",
    isStaticDisabled: true,
  },
  {
    id: "register-deal",
    title: "Register New Deal",
    subtitle: "Start a new project deal",
    customIcon: "register-deal-file",
    iconVariant: "light",
    isStaticDisabled: true,
  },
];

/** Static until backend enables end_customer_launches in /dashboard/stats/ */
export const STATIC_END_CUSTOMER_LAUNCHES: LaunchMetric[] = [
  {
    id: "organizations",
    title: "End Customer Organizations",
    subtitle: "TOTAL",
    value: "0",
    details: [
      { label: "Jan 2025", value: "0" },
      { label: "Feb 2025", value: "0" },
    ],
    footer: {
      label: "Net Launches",
      value: "0",
    },
  },
  {
    id: "user-adoption",
    title: "User Adoption",
    subtitle: "ACTIVE USERS",
    value: "0",
    details: [
      { label: "Jan 2025", value: "0" },
      { label: "Feb 2025", value: "0" },
    ],
  },
  {
    id: "licenses",
    title: "Licenses",
    subtitle: "TOTAL LICENSED USERS",
    value: "0",
    details: [
      { label: "Active", value: "0" },
      { label: "Provisioned", value: "0" },
    ],
  },
  {
    id: "activation-rate",
    title: "Activation Rate",
    subtitle: "CONVERSION EFFICIENCY",
    value: "0 %",
    details: [
      { label: "Target Base", value: "0" },
      { label: "Activated", value: "0" },
    ],
  },
  {
    id: "credentials",
    title: "Credentials",
    subtitle: "TOTAL",
    value: "0",
    details: [{ label: "Issued (Current Year)", value: "0" }],
  },
  {
    id: "mobile-arr",
    title: "Mobile ARR",
    subtitle: "ANNUAL RECURRING REVENUE",
    value: "$0",
    details: [{ label: "Projected 2026", value: "$0" }],
  },
];
